// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33N0P","selected":"styles_selected__3nAfJ"};